import { Shield } from "lucide-react";
import { LANDING_TRUST_HIGHLIGHTS } from "@/lib/landingMarketing";

/**
 * Renders a statistics section with user and asset information.
 * @example
 * StatsSection()
 * <section>...</section>
 * @return {JSX.Element} A section element containing statistics and visual content.
 * @description
 *   - Utilizes Tailwind CSS for styling and layout.
 *   - Responsive design adjustments for various screen sizes.
 *   - Displays user count and assets tracked in a visually appealing format.
 */
export function StatsSection() {
  return (
    <section className="bg-gradient-to-r from-orange-50 to-orange-100/50 py-8">
      <div className="container mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-8 items-center max-w-5xl mx-auto">
          <div className="order-2 md:order-1">
            <h2 className="text-2xl md:text-3xl font-bold mb-4 text-center md:text-left">
              Built for Your Wealth Journey
            </h2>
            <p className="text-lg text-gray-600 mb-6 text-center md:text-left">
              Track PF, mutual funds, gold, real estate, and more — with tools designed for Indian
              households and families.
            </p>
            <div className="grid grid-cols-2 gap-4">
              {LANDING_TRUST_HIGHLIGHTS.map((highlight) => (
                <div
                  key={highlight.label}
                  className="bg-white p-4 rounded-lg shadow-sm border border-orange-100"
                >
                  <p className="text-3xl font-bold text-orange-600 mb-1">{highlight.value}</p>
                  <p className="text-gray-600 text-sm">{highlight.label}</p>
                </div>
              ))}
            </div>
          </div>
          <div className="relative order-1 md:order-2">
            <div className="bg-white rounded-xl p-6 shadow-lg border border-orange-100">
              <div className="flex items-center gap-3 mb-4">
                <Shield className="w-8 h-8 text-orange-500" />
                <div>
                  <p className="font-semibold text-gray-900">Enterprise Security</p>
                  <p className="text-sm text-gray-600">Bank-grade protection</p>
                </div>
              </div>
              <div className="space-y-2">
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  <span className="text-sm text-gray-600">256-bit Encryption</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  <span className="text-sm text-gray-600">SOC 2 Type II Compliant</span>
                </div>
                <div className="flex items-center gap-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full"></div>
                  <span className="text-sm text-gray-600">Multi-factor Authentication</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
